import React from 'react';
import './chapter.css'
const Chapter13_2 = () => (
  <div>
    <h2>Purpose of Includes</h2>
    <p>
      The primary purpose of includes in AVAP is to promote modularity and code reuse. By dividing code into separate modules or files and then including them in main files as needed, developers can write and maintain code in a more organized and structured manner. This facilitates the management of large and complex projects, as well as collaboration between development teams.
    </p>
  </div>
);

export default Chapter13_2;
